export const customTTL = 1 * 60 * 60;

export const payTypes = [
    {id:0,title:"نقد"},
    {id:1,title:"چک/واریز"},
    {id:2,title:"اعتباری"},
    {id:3,title:"تخفیف"},
]

export const installationType = [
    {id:0,title:"نامشخص"},
    {id:1,title:"یکطرفه"},
    {id:2,title:"دوطرفه"},
    {id:3,title:"دوطرفه فول کوئری"},
]

export const connectionType = [
    {id:0,title:"نامشخص"},
    {id:1,title:"کابل"},
    {id:2,title:"شبکه"},
    {id:3,title:"فایل"},
]


export const buySMSCreditOptions = [
    {id:20000000,title:"2,000,000 تومان"},
    {id:30000000,title:"3,000,000 تومان"},
    {id:40000000,title:"4,000,000 تومان"},
    {id:50000000,title:"5,000,000 تومان"},
    {id:100000000,title:"10,000,000 تومان"},
    {id:200000000,title:"20,000,000 تومان"},
    {id:300000000,title:"30,000,000 تومان"},
    {id:400000000,title:"40,000,000 تومان"},
    {id:500000000,title:"50,000,000 تومان"},
]